module.exports = "images/file-big.png";